module.exports = __webpack_public_path__ + "static/img/icon-historical.76e204d2.svg";